import _jsx from '@babel/runtime/helpers/esm/jsx';
import _styled, { ThemeProvider } from 'styled-components';
import { memo } from 'react';
import Banners from '@dbh/banners';
import Header from '@dbh/header';
import HTMLContentSection from '@dbh/html-content-section';
import withLegacyAdapter from '@dbh/legacy-adapter';
import LinksSection from '@dbh/links-section';
import '@dbh/styled-helpers';
import { ADMINDEV_WEBCONTROLS_REFERENCES } from '@dbh/admindev-constants';
import { makeSelectWebcontrolWithRootAndLinksByReferenceRegexString } from '@dbh/webcontrols-redux';
import { THEME_KEY_TAPPABLE_HOTEL_CARD } from '@dbh/tappable-hotel-card-theme';
import { RESTART_ON_REMOUNT, useBrowserOnlyInjectSaga } from '@dbh/redux-extra';
import { select, call, all, takeEvery } from 'redux-saga/effects';
import { isServerSideRendering } from '@dbh/environment';
import { makeSelectHotels, HOTELS_LOADED } from '@dbh/hotels-redux';
import { takeOnce } from '@dbh/redux-saga-extra';
import { CAN_FIRE_PAGE_VIEW_TRACKING_EVENT } from '@dbh/tracking-scripts-redux';
import { handleAnalyticsEventSent } from '@dbh/analytics-redux';
import createAnalyticsEventViewItemList from '@dbh/create-analytics-event-view-item-list';
import { makeSelectIsFirstPageAfterSsr } from '@dbh/routing-redux';
import '@dbh/throw-in-server-side-rendering';
import { jsxs, Fragment } from 'react/jsx-runtime';
import { HotelCardList } from './index.js';
import '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import 'react-redux';
import '@dbh/hotel-card-list';
import '@dbh/hotel-card';
import '@dbh/media-queries';
import '@dbh/reselect-extra';
import '@dbh/section';
import '@dbh/smart-section';
import '@dbh/search-box-redux';
import 'reselect';

const makeSelectFlagContentPageLinks=()=>makeSelectWebcontrolWithRootAndLinksByReferenceRegexString(ADMINDEV_WEBCONTROLS_REFERENCES.FLAG_CONTENT_PAGE_LINKS);var makeSelectFlagContentPageLinks$1 = makeSelectFlagContentPageLinks;

const modifyTheme=a=>{const{[THEME_KEY_TAPPABLE_HOTEL_CARD]:b,colors:{greyLight:c}}=a;return {...a,[THEME_KEY_TAPPABLE_HOTEL_CARD]:{...b,sm:{boxShadow:"0px 1px 6px "+c}}}};var modifyTheme$1 = modifyTheme;

/**
 * Fires the native `view_item_list` `GA4` event in the browser, in the
 * `FlagContentPage`.
 * @yields {void} .
 */function*handleHotelsLoaded(){const a=yield select(makeSelectIsFirstPageAfterSsr()),b=yield select(makeSelectHotels()),c=!b||b.isEmpty();if(!c){// We are willing to make an extra `collect` (`GA4`) `API` call in the landing
// page when there are no search results, as it's a limited case.
yield call(handleAnalyticsEventSent,createAnalyticsEventViewItemList({hotels:b}),{sendOnVisibilityChange:a&&!c});}}

/*
 *
 * Constants: `@dbh/flag-content-page`.
 *
 */const REDUX_AND_SAGA_KEY="flagContentPage";

function*flagContentPageRootSaga(){isServerSideRendering()||(yield all([// Landing page.
takeOnce(CAN_FIRE_PAGE_VIEW_TRACKING_EVENT,handleHotelsLoaded),// Navigation.
takeEvery(HOTELS_LOADED,handleHotelsLoaded)]));}const injectedSagaConfiguration={key:REDUX_AND_SAGA_KEY,mode:RESTART_ON_REMOUNT};

const injectSagaOptions=Object.freeze({...injectedSagaConfiguration,saga:flagContentPageRootSaga}),useBrowserOnlyFlagContentPageSaga=()=>useBrowserOnlyInjectSaga(injectSagaOptions);var useBrowserOnlyFlagContentPageSaga$1 = useBrowserOnlyFlagContentPageSaga;

var _Fragment;const FlagContentPage=/*#__PURE__*/memo(()=>(useBrowserOnlyFlagContentPageSaga$1(),_Fragment||(_Fragment=/*#__PURE__*/jsxs(Fragment,{children:[/*#__PURE__*/_jsx(Header,{}),/*#__PURE__*/_jsx(Banners,{}),/*#__PURE__*/_jsx(ThemeProvider,{theme:modifyTheme$1},void 0,/*#__PURE__*/_jsx(_StyledHTMLContentSection,{innerStyle:"border-bottom: none;"})),/*#__PURE__*/_jsx(HotelCardList,{}),/*#__PURE__*/_jsx(LinksSection,{makeSelectWebcontrolsLinksData:makeSelectFlagContentPageLinks$1})]}))));FlagContentPage.displayName="FlagContentPage";var component = withLegacyAdapter(FlagContentPage);var _StyledHTMLContentSection=/*#__PURE__*/_styled(HTMLContentSection).withConfig({componentId:"sc-1ts6jm2-0"})(["padding:.2rem 0 0;"]);

export { component as default };
